import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { useTheme } from "../../contexts/ThemeContext";
import logo from "../../img/logo.png";
import "./Header.css";

interface HeaderProps {
  drawerOpen: boolean;
  onToggleDrawer: () => void;
  showToggle?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  drawerOpen,
  onToggleDrawer,
  showToggle = true,
}) => {
  const { currentLanguage, changeLanguage, availableLanguages, t } =
    useLanguage();
  const { isDark, toggleTheme } = useTheme();

  const languageLabels: { [key: string]: string } = {
    de: "DE",
    en: "EN",
    ua: "UA",
  };

  return (
    <header className="header">
      <div className="header-content">
        <div className="header-left">
          {showToggle && (
            <button
              className="drawer-toggle-btn"
              onClick={onToggleDrawer}
              title={t("toggle_sidebar")}
            >
              {drawerOpen ? "◀" : "☰"}
            </button>
          )}
          <img className="header-logo" src={logo} alt="" />
          <h1 className="header-title">IMPLEX</h1>
        </div>

        <div className="header-right">
          <button
            className="theme-toggle-btn"
            onClick={toggleTheme}
            title={t("toggle_theme")}
          >
            {isDark ? "☀️" : "🌙"}
          </button>

          <div className="language-selector">
            {availableLanguages.map((lang) => (
              <button
                key={lang}
                className={`language-btn ${
                  currentLanguage === lang ? "active" : ""
                }`}
                onClick={() => changeLanguage(lang)}
              >
                {languageLabels[lang]}
              </button>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
